import { useTranslation } from 'react-i18next';
import { Box, Button, Typography } from '@mui/material';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import PauseIcon from '@mui/icons-material/Pause';
import ProgressBar from '@core/devices/components/DevicesTest/ProgressBar';
import { STEP_TESTS } from '@core/devices/constants/devicesSteps';
import {
  useInitHeadphonesDevices,
  useSpeakerTest,
} from '@core/devices/components/DevicesTest/SpeakerTest/hooks';
import ProgressBarSelection from '@core/devices/components/DevicesTest/ProgressBarSelection';
import LoadingProgress from '@components/LoadingProgress';

import { useStyles } from './styles';
import HelperBox from '../HelperBox';

const SpeakerTest = () => {
  const { initializing, devices, activeDeviceId, setActiveDeviceId } =
    useInitHeadphonesDevices();
  const { loading, seconds, duration, isPlaying, handleSound } =
    useSpeakerTest();
  const { t: translate } = useTranslation();

  const classes = useStyles({ isPlaying });
  const buttonText = translate(
    isPlaying
      ? 'devicesTest.speakerTest.pauseButton'
      : 'devicesTest.speakerTest.playButton',
  );

  if (initializing || loading) {
    return <LoadingProgress />;
  }

  return (
    <Box>
      <Box sx={classes.root}>
        <Box sx={classes.playButtonWrapper}>
          <Button disableRipple sx={classes.playButton} onClick={handleSound}>
            {isPlaying ? <PauseIcon /> : <PlayArrowIcon />}
          </Button>
          <Typography sx={classes.playButtonText}>{buttonText}</Typography>
        </Box>
        <Box sx={classes.selectionContainer}>
          <ProgressBar value={seconds} max={duration} />
          <ProgressBarSelection
            devices={devices}
            activeDeviceId={activeDeviceId}
            onDeviceChange={setActiveDeviceId}
            disabled={isPlaying}
            sx={classes.selection}
            typeOfDevice={STEP_TESTS.SPEAKER}
          />
        </Box>
      </Box>
      <HelperBox
        title={translate('devicesTest.speakerTest.helper.title')}
        text={translate('devicesTest.speakerTest.helper.text')}
      />
    </Box>
  );
};

export default SpeakerTest;
